import React, { useContext, useState, useEffect } from "react";
import { CONSTANTS } from "../utils/constants";

const FilterContext = React.createContext();

export function useFilter() {
	return useContext(FilterContext);
}

export function FilterProvider({ children }) {
	const [selectedDistributor, setSelectedDistributor] = useState(null);
	const [selectedLaboratory, setSelectedLaboratory] = useState(null);
	const [selectedPharmacy, setSelectedPharmacy] = useState(null);
	const [selectedPointOfSale, setSelectedPointOfSale] = useState(null);
	const [selectedProvince, setSelectedProvince] = useState(null);
	const [rangeDate, setRangeDate] = useState(null);
	const [dateFrom, setDateFrom] = useState(null);
	const [dateTo, setDateTo] = useState(null);
	const [mobilePeriod, setMobilePeriod] = useState(CONSTANTS.PERIOD_CURRENT);
	const [selectedFilters, setSelectedFilters] = useState([]);
	const [featuredProductIndexFilter, setFeaturedProductIndexFilter] = useState(
		CONSTANTS.FEATURED_CATALOG,
	);
	const [marketOrdersLaboratoryId, setMarketOrdersLaboratoryId] =
		useState(null);
	const [marketOrdersDistributorId, setMarketOrdersDistributorId] =
		useState(null);
	const [marketOrdersPharmacyId, setMarketOrdersPharmacyId] = useState(null);
	const [marketOrdersPointOfSaleId, setMarketOrdersPointOfSaleId] =
		useState(null);
	const [marketOrdersSellerId, setMarketOrdersSellerId] = useState(null);
	const [marketOrdersProvinceName, setMarketOrdersProvinceName] =
		useState(null);
	const [marketOrdersTypeOfSale, setMarketOrdersTypeOfSale] = useState(null);
	const [marketOrdersOrderState, setMarketOrdersOrderState] = useState(null);
	const [marketOrdersOrdersRange, setMarketOrdersOrdersRange] = useState(null);
	const [marketOrdersOrdersFrom, setMarketOrdersOrdersFrom] = useState(null);
	const [marketOrdersOrdersTo, setMarketOrdersOrdersTo] = useState(null);
	const [selectedTypeOfSale, setSelectedTypeOfSale] = useState(null);
	const [selectedSeller, setSelectedSeller] = useState(null);
	const [sellerDashboardDisplay, setSellerDashboardDisplay] = useState(
		CONSTANTS.DASHBOARD_SALES,
	);
	const [ordersLabSellerId, setOrdersLabSellerId] = useState(null);
	const [adminUsersType, setAdminUsersType] = useState(CONSTANTS.USERS_WEB);
	const [marketUsersType, setMarketUsersType] = useState(CONSTANTS.USERS_WEB);
	const [generalConfigOT, setGeneralConfigOT] = useState(
		CONSTANTS.MODULE_ONE_TRANSFER,
	);
	const [generalConfigLab, setGeneralConfigLab] = useState(null);
	const [userRol, setUserRol] = useState(null);
	const [userSellerId, setUserSellerId] = useState(null);
	const [configType, setConfigType] = useState(CONSTANTS.CONFIG_WEB);
	const [oneTransferSection, setOneTransferSection] = useState("general");
	const [marketplaceSection, setMarketplaceSection] = useState("general");

	const value = {
		selectedDistributor,
		setSelectedDistributor,
		selectedLaboratory,
		setSelectedLaboratory,
		selectedPharmacy,
		setSelectedPharmacy,
		selectedPointOfSale,
		setSelectedPointOfSale,
		selectedProvince,
		setSelectedProvince,
		rangeDate,
		setRangeDate,
		dateFrom,
		setDateFrom,
		dateTo,
		setDateTo,
		mobilePeriod,
		setMobilePeriod,
		selectedFilters,
		setSelectedFilters,
		featuredProductIndexFilter,
		setFeaturedProductIndexFilter,
		marketOrdersLaboratoryId,
		setMarketOrdersLaboratoryId,
		marketOrdersDistributorId,
		setMarketOrdersDistributorId,
		marketOrdersPharmacyId,
		setMarketOrdersPharmacyId,
		marketOrdersPointOfSaleId,
		setMarketOrdersPointOfSaleId,
		marketOrdersSellerId,
		setMarketOrdersSellerId,
		marketOrdersTypeOfSale,
		marketOrdersProvinceName,
		setMarketOrdersProvinceName,
		setMarketOrdersTypeOfSale,
		marketOrdersOrderState,
		setMarketOrdersOrderState,
		marketOrdersOrdersFrom,
		setMarketOrdersOrdersFrom,
		marketOrdersOrdersTo,
		setMarketOrdersOrdersTo,
		marketOrdersOrdersRange,
		setMarketOrdersOrdersRange,
		selectedTypeOfSale,
		setSelectedTypeOfSale,
		selectedSeller,
		setSelectedSeller,
		sellerDashboardDisplay,
		setSellerDashboardDisplay,
		ordersLabSellerId,
		setOrdersLabSellerId,
		adminUsersType,
		setAdminUsersType,
		marketUsersType,
		setMarketUsersType,
		generalConfigOT,
		setGeneralConfigOT,
		generalConfigLab,
		setGeneralConfigLab,
		userRol,
		setUserRol,
		userSellerId,
		setUserSellerId,
		configType,
		setConfigType,
		oneTransferSection,
		setOneTransferSection,
		marketplaceSection,
		setMarketplaceSection,
	};

	return (
		<FilterContext.Provider value={value}>{children}</FilterContext.Provider>
	);
}
